module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB5SURBVHgB7ZPBDYAgDEW/xptL4CTMziSyhGetB4wh2qKNWhPehZDS/D4IwN9puOLk/UiLA0/sQxjOii14HGTYMx0KoAkPTclwFlpFAzXbZCXTXCFZv2eQ0Jrk7/W4gY2AVXuvnu/VARpqwPcB9aMZDKALjLiJptcuCyMRHWEyb6MyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./packages/assets/delete-red.png
// module id = djtH
// module chunks = 1